import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

function Spacer({ classes }) {
  return <div className={classes.root} />;
}

Spacer.propTypes = {
  classes: PropTypes.object.isRequired,
};

const stylesheet = {
  root: {
    flex: 1,
  },
};

export default injectSheet(stylesheet)(Spacer);



// WEBPACK FOOTER //
// ./src/site-render/src/Spacer/Spacer.js